// extracted by mini-css-extract-plugin
export default {"root":"IconArrowBack_root__t0DYv"};